import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { useCallback, useContext } from 'react';
import { useTheme } from 'styled-components';

const useGetApplicationStatusConfig = () => {
  const { t } = useContext(ConfigContext);
  const theme = useTheme();

  const getApplicationStatusConfig = useCallback(
    (status) => {
      switch (status) {
        case 'released':
          return { label: t('released'), background: theme.colors.redExtraLight, color: theme.colors.redNegative };
        case 'rejected':
          return { label: t('rejected'), background: theme.colors.redExtraLight, color: theme.colors.redNegative };
        case 'pending':
          return { label: t('pending'), background: theme.colors.blueLight, color: theme.colors.generalBlue };
        case 'booked':
          return { label: t('booked'), background: theme.colors.greenExtraLight, color: theme.colors.greenPositive };
        default:
          return { label: status || t('pending'), background: theme.colors.blueLight, color: theme.colors.generalBlue };
      }
    },
    [t, theme]
  );

  return getApplicationStatusConfig;
};

export default useGetApplicationStatusConfig;
